import { React } from "react";
import { FaArrowUp } from "react-icons/fa";

const TimelineBlock = ({ year, from, to, children, isFirst }) => {
  const circleIcon = !isFirst ? (
    <div className="absolute -top-1 -left-10 before:block before:h-20 before:w-20 before:rounded-full before:border-4 before:border-solid before:border-light-complemetary before:bg-white before:content-[''] dark:before:bg-dark-secondary-1">
      <div className="absolute top-5 left-3 h-5 w-14 text-center font-google-baloo text-xl font-bold text-light-complemetary">
        {year}
      </div>
      <div className="absolute top-10 left-2 block h-5 w-16 text-center text-sm text-light-complemetary">
        {from}
      </div>
    </div>
  ) : (
    <div className="absolute -top-7 -left-5 text-4xl font-bold text-light-complemetary">
      <FaArrowUp />
    </div>
  );
  return (
    <div class="flex w-full items-center">
      <div class="relative block w-full border-l-2 border-dotted border-light-complemetary">
        {circleIcon}
        <div className="relative left-16 w-full border-l-8 border-solid border-light-secondary-1 p-5 hover:border-light-complemetary dark:border-dark-secondary-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default TimelineBlock;
